(function () {
  "use strict";

  function parseJson(id) {
    var node = document.getElementById(id);
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || "[]");
    } catch (error) {
      return [];
    }
  }

  function initMenu(root) {
    var button = root.querySelector(".menu-toggle");
    var menu = root.querySelector("#primary-menu");
    if (!button || !menu) return;

    function closeMenu() {
      menu.classList.remove("is-open");
      document.body.classList.remove("menu-is-open");
      button.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-label", "Open menu");
    }

    button.addEventListener("click", function () {
      var open = !menu.classList.contains("is-open");
      menu.classList.toggle("is-open", open);
      document.body.classList.toggle("menu-is-open", open);
      button.setAttribute("aria-expanded", String(open));
      button.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    });

    menu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeMenu);
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 900) closeMenu();
    });
  }

  function enforceOriginalImageAssets(root) {
    root.querySelectorAll("img[srcset]").forEach(function (image) {
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
    });
  }

  function initHero(root) {
    var hero = root.querySelector(".live-hero");
    var slides = parseJson("v84-hero-data");
    if (!hero || slides.length < 2) return;

    var media = hero.querySelector(".hero-media");
    var image = media && media.querySelector("img");
    var copy = hero.querySelector(".live-hero-copy");
    var label = copy && copy.querySelector("p");
    var title = copy && copy.querySelector("h2");
    var description = copy && copy.querySelector("span");
    var action = copy && copy.querySelector("a");
    var pause = hero.querySelector(".hero-pause");
    var dots = Array.prototype.slice.call(hero.querySelectorAll(".hero-dots button"));
    if (!media || !image || !label || !title || !description || !action) return;

    var index = 0;
    var timer = null;
    var paused = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var interval = 10000;

    function render(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      var slide = slides[index];
      image.src = slide.image;
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.alt = slide.alt || "Kisskind homepage campaign";
      media.href = slide.href || "#shop";
      label.textContent = slide.label || "KISSKIND";
      title.textContent = slide.title || "";
      description.textContent = slide.copy || "";
      action.textContent = slide.action || "Explore";
      action.href = slide.href || "#shop";
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle("is-active", active);
        dot.setAttribute("aria-pressed", String(active));
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!paused) {
        timer = window.setInterval(function () {
          render(index + 1);
        }, interval);
      }
    }

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener("click", function () {
        render(dotIndex);
        start();
      });
    });

    if (pause) {
      pause.textContent = paused ? "Play" : "Pause";
      pause.setAttribute("aria-pressed", String(paused));
      pause.addEventListener("click", function () {
        paused = !paused;
        pause.textContent = paused ? "Play" : "Pause";
        pause.setAttribute("aria-pressed", String(paused));
        start();
      });
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop();
      else start();
    });

    render(0);
    start();
  }

  function initColorDuo(root) {
    var colors = parseJson("v84-color-data");
    var left = root.querySelector(".duo-cup--left");
    var right = root.querySelector(".duo-cup--right");
    if (!colors.length || !left || !right) return;

    var state = { left: 0, right: Math.min(5, colors.length - 1) };
    var timers = { left: null, right: null };

    function render(side) {
      var button = side === "left" ? left : right;
      var current = colors[state[side]];
      var image = button.querySelector("img");
      if (!image || !current) return;
      image.src = current[side];
      image.alt = side + " Kisskind cup in " + current.name;
      button.setAttribute("aria-label", "Change " + side + " cup color. Currently " + current.name);
    }

    function advance(side) {
      state[side] = (state[side] + 1) % colors.length;
      render(side);
    }

    function startCycle(side) {
      if (timers[side]) return;
      advance(side);
      timers[side] = window.setInterval(function () {
        advance(side);
      }, 1200);
    }

    function stopCycle(side) {
      if (timers[side]) window.clearInterval(timers[side]);
      timers[side] = null;
    }

    [["left", left], ["right", right]].forEach(function (entry) {
      var side = entry[0];
      var button = entry[1];
      button.addEventListener("mouseenter", function () { startCycle(side); });
      button.addEventListener("mouseleave", function () { stopCycle(side); });
      button.addEventListener("focus", function () { startCycle(side); });
      button.addEventListener("blur", function () { stopCycle(side); });
      button.addEventListener("click", function () {
        stopCycle(side);
        advance(side);
      });
    });

    render("left");
    render("right");
  }

  function init() {
    var root = document.querySelector(".kisskind-v84-home");
    if (!root) return;
    enforceOriginalImageAssets(root);
    initMenu(root);
    initHero(root);
    initColorDuo(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
